import { __extends } from '../../node_modules/tslib/tslib.es6.js';
import { ApexSlotableMixin } from '../../node_modules/@fmr-pr103625/apex-slots/dist/esm2015/utils.js';
import { PvdBaseComponent } from './pvd-base-component.js';

var PvdSlotifyBaseComponent = /** @class */ (function (_super) {
    __extends(PvdSlotifyBaseComponent, _super);
    function PvdSlotifyBaseComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PvdSlotifyBaseComponent.prototype.hasSlotableContent = function (slotName) {
        if (slotName === void 0) { slotName = 'default'; }
        return _super.prototype.hasSlotableContent.call(this, slotName, {
            ignoreComments: true,
            ignoreWhitespace: true,
        });
    };
    PvdSlotifyBaseComponent.prototype.isSlotUsed = function (slotName) {
        if (slotName === void 0) { slotName = 'default'; }
        return this.hasSlotableContent(slotName) || this.hasAssignedSlotContent(slotName);
    };
    return PvdSlotifyBaseComponent;
}(ApexSlotableMixin(PvdBaseComponent)));

export { PvdSlotifyBaseComponent };
